export const ApiUrl = 'https://nexus-api.fidgi.ca';
// export const ApiUrl = 'https://nexus-v2-api.fidgi.ca';
// export const ApiUrl = 'https://fidgi-api.66loop.com';
